import SimpleQuestion from "./SimpleQuestion";
import * as theme from "../theme";
import { INSURER } from "../store/businesslogic/hardwiredlogic";
import { useState } from "react";

const SimpleString = ({
  text,
  node,
  handleAnswerChange,
  isNodeOpen,
  qfusermode,
}) => {
  return (
    <SimpleQuestion
      leftString={text}
      node={node}
      rightComponent={
        <StringInput
          node={node}
          handleAnswerChange={handleAnswerChange}
          qfusermode={qfusermode}
        ></StringInput>
      }
    ></SimpleQuestion>
  );
};

export const StringInput = ({ node, handleAnswerChange, qfusermode }) => {
  // const currentnode = useSelector(getCurrentNode);
  // const isOnThisNode = node.id === currentnode.id;
  const [input, setInput] = useState(node.answer ? node.answer : "");

  const handleBlur = (event) => {
    if (node.answer != input) handleAnswerChange(input);
  };

  const handleChange = (event) => {
    setInput(event.target.value);
  };
  // const dispatch = useDispatch();
  return (
    <input
      type="text"
      id={"stringInput" + node.id}
      style={{ ...theme.inputStyle }}
      value={input}
      onBlur={handleBlur}
      onChange={handleChange}
      readOnly={qfusermode === INSURER ? true : false}
    ></input>
  );
};

export const StringInputForMiniForm = ({
  node,
  handleAnswerChange,
  code,
  questionid,
  qfusermode,
}) => {
  // code = "ENGLISH";
  // questionid = "internal_1";
  // node = {
  //   answer: { internal: { ENGLISH: { internal_1: "hello this is answer" } } },
  // };
  const decideTheValue = (code, node, questionid) => {
    if (!node) return "";
    if (!node.answer) return "";
    if (!node.answer.internal) return "";
    if (!node.answer.internal[code]) return "";
    if (!node.answer.internal[code][questionid]) return "";

    return node.answer.internal[code][questionid];
  };

  const handleChange = (event) => {
    handleAnswerChange(code, questionid, event.target.value);
  };
  return (
    <input
      type="text"
      id={`numberInput_${node.id}_${code}_${questionid}`}
      style={{
        backgroundColor: theme.COLORS.tertiary_ligthindigo,
        height: "5vh",
        width: "12vw",
        border: 0,
        borderRadius: 5,
        padding: "2vmin",
      }}
      value={decideTheValue(code, node, questionid)}
      onChange={handleChange}
      readOnly={qfusermode === INSURER ? true : false}
    ></input>
  );
};

export default SimpleString;
